import React from 'react';
import './InfoMarcas.css';

//images
// import marcaClassic from '../images/Marcas/ledesma-classic.svg';
// import marcaAutor from '../images/Marcas/marca-autor.svg';
// import marcaDesign from '../images/Marcas/marca-design.svg';
// import marcaExecutive from '../images/Marcas/marca-executive.svg';
// import marcaExito from '../images/Marcas/marca-exito.svg';
// import marcaGloria from '../images/Marcas/marca-gloria.svg';
// import marcaLedNat from '../images/Marcas/marca-ledesma-nat.svg';
// import marcaLed from '../images/Marcas/marca-ledesma.svg';
// import marcaBio from '../images/Marcas/marcabio.svg';

export default function InfoMarcas () {

    return (
        <div className="containerInfoMarcas">
            Soy Marcas
        </div>
    );
};
